import React from "react";
import Section from "components/Section";
import Container from "react-bootstrap/Container";
import SectionHeader from "components/SectionHeader";

function TermsAndConditionsGeneral(props) {
  return (
    <Section>
      <Container>
              <SectionHeader
                className="text-center"
                title="Tinkamumo reikalavimai"
                size={1}
                spaced={true}
              />
<p>Puslapis paskutinį kartą buvo atnaujintas 2022-02-03</p>              
<p>Norėdami rezervuoti TryMyCar automobilius ar registruoti juos platformoje turite atitikti žemiau nurodytus reikalavimus.</p>
<h1>Vairuotojo tinkamumo reikalavimai</h1>
<p>Norėdami rezervuoti ir vairuoti automobilį per TryMyCar platformą Jūs turite atitikti visas &scaron;ias sąlygas:</p>
<ol>
<li>Nuomos pradžios dieną Jums turi būti daugiau nei 20 metų.</li>
<li>Per pastaruosius trejus metus nesate bausti už sunkius kelių eismo taisyklių pažeidimus ir nesate bausit dėl alkoholio ar narkotikų vartojimo vairuojant paskutinius de&scaron;imt metų. Taip pat neturite kitų administracinių nuobaudų susijusių su alkoholiu ar narkotinėmis medžiagomis.</li>
<li>Nesate bausti už vairavimo taisyklių pažeidimus daugiau kaip du kartus per paskutinius tris metus.</li>
<li>Vairuotojai kurie yra jaunesni nei 25 metų negali turėti jokių vairavimo taisyklių pažeidimų per pastaruosius tris metus.</li>
<li>Vairuotojai kurie nėra Lietuvos respublikos rezidentai, turi būti ne jaunesni nei 25 metai nuomos periodo pradžioje.</li>
</ol>
<p><strong>Vairuotojo tinkamumą patvirtinantys dokumentai</strong></p>
<ol>
<li>Vairavimo istoriją patvirtinantys i&scaron;ra&scaron;ai turi būti pateikti TryMyCar ar suteiktas leidimas juos gauti vairuotojo vardu prie&scaron; pradedant naudotis TryMyCar paslaugomis.</li>
<li>Vairavimo istoriją patvirtinantys i&scaron;ra&scaron;ai gauti TryMyCar vairuotojo vardu negali būti perduoti vairuotojui.</li>
</ol>
<p><strong>Vairuotojo tinkamumo stebėsena</strong></p>
<ol>
<li>TryMyCar gali periodi&scaron;kai papra&scaron;yti atnaujinti vairavimo istoriją patvirtinančius dokumentus ar duoti leidimą i&scaron; naujo patikrinti vairuotojo vairavimo istoriją.</li>
<li>Mes galime kreiptis į vairuotoją norėdami patikrinti gautus prane&scaron;imus, kaip:
<ol>
<li>Prane&scaron;imas apie pritaikytą administracinę nuobaudą, draudiminį įvykį;</li>
<li>Gautas skundas apie netinkamą vairavimą;</li>
<li>&bdquo;TMC saugiai&ldquo; sistemos prane&scaron;imas apie užfiksuotą netinkamą vairavimą.</li>
</ol>
</li>
</ol>
<h2>Automobilio tinkamumas</h2>
<p>Jūsų automobilis turi atitikti &scaron;iuos minimalius reikalavimus prie&scaron; įkeliant į TryMyCar rezervavimo sistemą:</p>
<ol>
<li>Turi atitikti visus gamintojo reikalavimus ir būti tinkamai prižiūrėtas:
<ol>
<li>Savininkai registruojantys automobilius TrMyCar platformoje gali būti papra&scaron;yti pateikti dokumentus patvirtinantį paskutinį automobilio aptarnavimą ar atliktą remontą.</li>
<li>Savininkai privalo atlikti ir dokumentuoti periodinius aptarnavimus pagal gamintojo nustatytą grafiką.</li>
</ol>
</li>
<li>Automobilis turi atitikti visus gamintojo ir privalomos techninės apžiūros reikalavimus taip kaip juos apibrėžia <a href="https://e-seimas.lrs.lt/portal/legalAct/lt/TAD/TAIS.329833/pSEcbwCmbp">Privalomosios transporto priemonių techninės apžiūros atlikimo tvarkos apra&scaron;as</a>, <a href="https://www.e-tar.lt/portal/lt/legalAct/TAR.677E0A63A536/fDiFEWLnlf">Techninių motorinių transporto priemonių ir jų priekabų reikalavimai</a>, bei <a href="https://www.e-tar.lt/portal/lt/legalAct/TAR.5DC1759E42CB/EGylvEvhXc">Lietuvos Respublikos saugaus eismo automobilių keliais įstatymas</a> (&bdquo;Techninis stovis&ldquo;). Remiantis Jūsų pateiktais duomenimis TryMyCar gali kreiptis į Jūs pra&scaron;ant pateikti dokumentus pagrindžiančius tinkamą automobilio techninį stovį, atliktą remontą, ar periodinį patikrinimą. Nepateikus tinkamą automobilio būklę pagrindžiančių dokumentų TryMyCar suspenduos automobilį TryMyCar platformoje iki tinkamų dokumentų pateikimo.</li>
<li>Automobilis nuomos periodo pradžioje yra ne senesnis nei 10 metų ir jo rida yra ne didesnė nei 200&lsquo;000 kilometrų. Arba:</li>
<ol>
<li> Automobilis yra senesnis nei 10 metų ar neatitinka maksimalios ridos apribojimų, bet savininkas pateikia įrodymus patvirtinančius gerą automobilio techninę būklę.</li>
<li> Techninės būklės įrodymai turi būti pateikiami kas 12mėn, jų nepateikus, savininkas neturi teisės toliau nuomoti savo automobilį per Trymycar platformą.</li>
<li> Trymycar gali savo nuožiūra bet kada paprašyti pateikti papildomus įrodymus patvirtinančius gerą automobilio techninę būklę.</li>
</ol>
<li>Vidutinė automobilio rinkos vertė nėra didesnė nei 40000 eurų.</li>
<li>Automobilis ar jo agregatai nebuvo modifikuotas didinant jo galią, maksimalų greitį ar kitaip paveikiant jo saugumą. Jeigu automobilis buvo modifikuotas, priklausomai nuo modifikavimo, TryMyCar gali nuspręsti, kad automobilis yra netinkamas naudojimui per TryMyCar platformą dėl per didelės rizikos.</li>
<li>Automobilis turi ne daugiau kaip 9 sėdimas vietas.</li>
<li>Automobilis yra lengvasis automobilis kurio vairuotojas turi turėti B ar auk&scaron;tesnės kategorijos vairuotojo teises.</li>
<li>Savininkas privalo per Platformą pateikti aktualias automobilio nuotraukas patvirtinančias automobilio būklę ir atskleidžiančias visus matomus trūkumus.</li>
<li>&Scaron;ie automobilių modeliai negali būti rezervuojami per TryMyCar platformą ir pasinaudoti partnerių siūlomu kasko draudimu:</li>
  <ol>
  <li>Specifiniai modeliai:</li>
<p>Audi E-TRON, Q8, S, SQ and RS modifikacijos; BMW 500, 600, 700, 800, M modifikacijos, X5, X6, X7, I8; Jaguar; Mercedes, AMG, CLS, CLK, CL, G, GL, GLE, ML, S, SL, SLK; Porsche; Tesla; Lexus;</p>
<li>Prabangūs automobiliai:</li>
<p>Bentley, Ferrari , Lamborghini, Maserati, Porsche, Rolls-Royce ir kiti.</p>
<li>JAV gamintojų automobiliai:</li>
<p>Buick, Cadillac, Chevrolet, Lincoln, Hummer, GMC, Dodge ir kiti.</p>
<li>Istoriniai automobiliai, profesionalaus sporto ar lenktyniniai automobiliai (pvz. Ford Mustang, Honda Civic TYPE-R, Subaru WRX, Nissan GTR).</li>
  </ol>
</ol>
<ol start="10">
<li>Norint naudotis &bdquo;TMC saugiai&ldquo; prietaisu, automobilis turi atitikti suderinamumo reikalavimus.</li>
</ol>
<p>&nbsp;</p>
<p><strong>Automobilio tinkamumas </strong></p>
<ol>
<li>Siekiant įsitikinti automobilio tinkamumu, TryMyCar gali papra&scaron;yti pateikti tai įrodančius dokumentus ar duoti sutikimą gauti tai patvirtinančius i&scaron;ra&scaron;us i&scaron; registrų.</li>
<li>TryMyCar gali viena&scaron;ali&scaron;kai nuspręsti, ar automobilis tinka būti registruotas TryMyCar platformoje.</li>
<li> Nežiūrint visų priemonių kurių imasi Trymycar užtikrinti, kad platformoje būtų tik tinkami naudoti automobiliai, savininkas yra atsakingas už automobilio tinkamą naudojimui techninę būklę. </li>
</ol>
<p><strong>Automobilio tinkamumo stebėsena</strong></p>
<ol>
<li>TryMyCar gali periodi&scaron;kai papra&scaron;yti atnaujinti automobilio tinkamumą patvirtinančius dokumentus ar duoti leidimą gauti atnaujintus tai patvirtinančius i&scaron;ra&scaron;us.</li>
<li>Mes galime kreiptis į savininką norėdami patikrinti gautus prane&scaron;imus, kaip:
<ol>
<li>Prane&scaron;imas apie įvykusį draudiminį įvykį;</li>
<li>Gautas skundas apie automobilio būklę;</li>
<li>&bdquo;TMC saugiai&ldquo; sistemos prane&scaron;imas apie užfiksuotą gedimą.</li>
</ol>
</li>
</ol>
<h1>&nbsp;</h1>
        </Container>
    </Section>
  );
}

export default TermsAndConditionsGeneral;